import {Component} from "react";
import {withTranslation} from "react-i18next";

class HelpPage extends Component {
    constructor (props) {
        super (props)
    }

    componentDidMount = () => {
    }

    componentWillUnmount = () => {
    }

    render () {
        return (
            <div className="help-page">
                <div className="header-container">
                    <div className="header">
                        <div className="">{this.props.t('help_title')}</div>
                        <img className="durolt-logo" src={require("../assets/images/durolt_app_logo.png")} alt={this.props.t('durolt_logo')} />
                    </div>
                </div>
                <div className="main-container">
                    <div className="main"></div>
                </div>
                {/* <div className="footer-container">
                    <div className="footer"></div>
                </div> */}
            </div>
        );
    }
}

export default withTranslation()(HelpPage);
